import React, { useState } from 'react';

function FilterModal({ onFilter }) {
  const [statuses, setStatuses] = useState([]);
  const [siteName, setSiteName] = useState('');

  const handleCheck = (status) => {
    const existingIndex = statuses.findIndex((item) => item === status);
    const newArray = [...statuses];
    if (existingIndex >= 0) {
      newArray.splice(existingIndex, 1);
      setStatuses(newArray);
    } else {
      newArray.push(status);
      setStatuses(newArray);
    }
  };

  const filterData = () => {
    onFilter(siteName, statuses);
    document.getElementById('closeModal').click();
  };

  return (
    <div className="modal" tabIndex="-1" id="exampleModal">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Filter Data</h5>
            <button
              id="closeModal"
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="fw-600 mb-10">Nama Site</label>
              <input
                type="text"
                onChange={(e) => setSiteName(e.target.value)}
                className="form-control"
                value={siteName}
              />
            </div>
            <label htmlFor="checkboxes" className="fw-600 mb-10">
              Status :
            </label>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('NEW_REQUEST')}
                checked={statuses.includes('NEW_REQUEST')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">New</div>
            </div>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('WAITING_FOR_APPROVAL')}
                checked={statuses.includes('WAITING_FOR_APPROVAL')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">In Progress</div>
            </div>
            <div className="form-checkbox d-flex items-center mb-10 ml-10">
              <input
                type="checkbox"
                onChange={() => handleCheck('APPROVED')}
                checked={statuses.includes('APPROVED')}
              />
              <div className="form-checkbox__mark">
                <div className="form-checkbox__icon icon-check" />
              </div>
              <div className="text-15 ml-10">Approved</div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              onClick={filterData}
              type="button"
              className="btn btn-primary bg-blue-1 rounded-1">
              Filter Data
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterModal;
